module.exports = __webpack_public_path__ + "img/m_2.46d3c984.png";